import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { LangsEnum, ProductsEnum, RouteParamTypesEnum } from '@src/app/enums';

@Injectable({
  providedIn: 'root',
})
export class PreloadService {
  private langs: any[] = [
    { name: LangsEnum.EN, id: 1 },
    { name: LangsEnum.HY, id: 2 },
  ];
  private productTypes: any[] = [
    { url: ProductsEnum.INDIVIDUAL, id: 3 },
    { url: ProductsEnum.BUSINESS, id: 4 },
    { url: ProductsEnum.AGRO, id: 5 },
  ];

  getLangs(): string[] {
    return this.langs.map((item) => item.name);
  }

  getLangId(code: string): number {
    return this.langs.find((l) => l.code === code)?.id ?? 2;
  }

  getProductTypesList(): string[] {
    return this.productTypes.map((item) => item.url);
  }

  getProductId(code: string): number {
    return this.productTypes.find((p) => p.url === code)?.id ?? 3;
  }

  private getParamFromTree(
    route: ActivatedRouteSnapshot,
    key: string,
  ): string | null {
    let current: ActivatedRouteSnapshot | null = route;

    while (current) {
      const value = current.paramMap.get(key);

      if (value) return value;

      current = current.parent;
    }

    return null;
  }

  public getRouteContext(route: ActivatedRouteSnapshot) {
    const langCode = this.getParamFromTree(route, RouteParamTypesEnum.LANG);
    const productCode = this.getParamFromTree(
      route,
      RouteParamTypesEnum.PRODUCT,
    );

    return {
      langCode,
      productCode,
      langId: langCode ? this.getLangId(langCode) : 2,
      productId: productCode ? this.getProductId(productCode) : 3,
    };
  }
}
